import guide from "@/assets/guide-francophone-siem-reap.jpg";

const Story = () => {
  return (
    <section id="story" className="bg-secondary grain py-28 md:py-40 relative">
      <div className="container grid md:grid-cols-12 gap-12 items-center">
        <div className="md:col-span-5 relative">
          <img
            src={guide}
            alt="Cambodian guide tracing temple bas-relief carvings"
            width={1280}
            height={1024}
            loading="lazy"
            className="w-full aspect-[4/5] object-cover shadow-editorial"
          />
          <div className="absolute -bottom-6 -right-6 hidden md:block bg-primary text-primary-foreground p-6 max-w-[220px] shadow-soft">
            <p className="font-display text-5xl leading-none">15</p>
            <p className="text-[11px] uppercase tracking-[0.3em] mt-2">Years guiding the temples of Angkor</p>
          </div>
        </div>

        <div className="md:col-span-6 md:col-start-7">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-5">— Our Philosophy</p>
          <h2 className="font-display text-4xl md:text-6xl leading-[1.05] mb-8 text-balance">
            We do not show you Cambodia. We <em className="font-light">introduce</em> you to her.
          </h2>
          <div className="space-y-5 text-muted-foreground font-light leading-relaxed text-lg">
            <p>
              Founded in Siem Reap by a former conservator at the Angkor Archaeological Park, Aṅkor Sojourns exists for the traveller who wants more than a photograph at sunrise.
            </p>
            <p>
              Our guides are Cambodian -  historians, monks-in-training, daughters of stonemasons. They speak of these temples not as ruins, but as relatives.
            </p>
          </div>

          <dl className="mt-12 grid grid-cols-3 gap-6 border-t border-border pt-8">
            {[
              ["8", "Travellers max"],
              ["100%", "Local guides"],
              ["3%", "To temple restoration"],
            ].map(([k, v]) => (
              <div key={v}>
                <dt className="font-display text-4xl text-foreground">{k}</dt>
                <dd className="text-[11px] uppercase tracking-[0.25em] text-muted-foreground mt-2">{v}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
};
export default Story;
